import { CartObject, CartPrice } from "@/types";
import { formatPrice } from "./formatPrice";

function useInstallmentNew(cart: CartObject, frete?) {
  let prices: CartPrice[] = [];
  // console.log("cartcartcart", cart);
  const cupom = cart?.cupom?.discount ? cart?.cupom?.discount : 0;
  for (let i = 0; i <= 12; i++) {
    let value =
      cart?.items
        ?.map((item) => ({
          price: item?.dashPrice
            ? item.pricesSite.filter((price) => price.parcel == i)[0]
            : item.prices.filter((price) => price.parcel == i)[0],
          qty: item.qty,
          priceDiscount: cart?.totalFreteNumber === 0 ? 0 : item?.priceDiscount,
          cupom: cart?.cupom?.discount ? cart?.cupom?.discount : 0
        }))
        .reduce((acc, obj) => acc.concat(obj), [])
        .reduce((acc, item) => (acc += (item?.price?.value - item?.priceDiscount) * item?.qty), 0) +
      cart?.totalFreteNumber;

    i === 0
      ? prices.push({
          desc: `À vista por R$${formatPrice(value.toFixed(2) - cupom)}`,
          value: value - cupom,
          parcel: 0
        })
      : prices.push({
          desc: `${i}x de ${formatPrice((value - cupom) / i)}`,
          value: (value - cupom) / i,
          parcel: i
        });
  }

  //   let x0 = frete ? frete : 0;
  //   let x1 = frete ? frete : 0;
  //   let x2 = frete ? frete : 0;
  //   let x3 = frete ? frete : 0;
  //   let x4 = frete ? frete : 0;
  //   let x5 = frete ? frete : 0;
  //   let x6 = frete ? frete : 0;
  //   let x7 = frete ? frete : 0;
  //   let x8 = frete ? frete : 0;
  //   let x9 = frete ? frete : 0;
  //   let x10 = frete ? frete : 0;
  //   let x11 = frete ? frete : 0;
  //   let x12 = frete ? frete : 0;

  // items?.forEach((prod) => {
  //   x0 += prod?.prices[0]?.value * prod?.qty;
  //   x1 += prod?.prices[1]?.value * prod?.qty;
  //   x2 += prod?.prices[2]?.value * prod?.qty;
  //   x3 += prod?.prices[3]?.value * prod?.qty;
  //   x4 += prod?.prices[4]?.value * prod?.qty;
  //   x5 += prod?.prices[5]?.value * prod?.qty;
  //   x6 += prod?.prices[6]?.value * prod?.qty;
  //   x7 += prod?.prices[7]?.value * prod?.qty;
  //   x8 += prod?.prices[8]?.value * prod?.qty;
  //   x9 += prod?.prices[9]?.value * prod?.qty;
  //   x10 += prod?.prices[10]?.value * prod?.qty;
  //   x11 += prod?.prices[11]?.value * prod?.qty;
  //   x12 += prod?.prices[12]?.value * prod?.qty;
  // });

  // const resp: CartPrice[] = [
  //   {
  //     desc: `À vista por R$${x0.toFixed(2)}`,
  //     value: x0,
  //     parcel: 0
  //   },
  //   {
  //     desc: `1x de R$${x1.toFixed(2)}`,
  //     value: x1,
  //     parcel: 1
  //   },
  //   {
  //     desc: `2x de R$${(x2 / 2).toFixed(2)}`,
  //     value: x2 / 2,
  //     parcel: 2
  //   },
  //   {
  //     desc: `3x de R$${(x3 / 3).toFixed(2)}`,
  //     value: x3 / 3,
  //     parcel: 3
  //   },
  //   {
  //     desc: `4x de R$${(x4 / 4).toFixed(2)}`,
  //     value: x4 / 4,
  //     parcel: 4
  //   },
  //   {
  //     desc: `5x de R$${(x5 / 5).toFixed(2)}`,
  //     value: x5 / 5,
  //     parcel: 5
  //   },
  //   {
  //     desc: `6x de R$${(x6 / 6).toFixed(2)}`,
  //     value: x6 / 6,
  //     parcel: 6
  //   },
  //   {
  //     desc: `7x de R$${(x7 / 7).toFixed(2)}`,
  //     value: x7 / 7,
  //     parcel: 7
  //   },
  //   {
  //     desc: `8x de R$${(x8 / 8).toFixed(2)}`,
  //     value: x8 / 8,
  //     parcel: 8
  //   },
  //   {
  //     desc: `9x de R$${(x9 / 9).toFixed(2)}`,
  //     value: x9 / 9,
  //     parcel: 9
  //   },
  //   {
  //     desc: `10x de R$${(x10 / 10).toFixed(2)}`,
  //     value: x10 / 10,
  //     parcel: 10
  //   },
  //   {
  //     desc: `11x de R$${(x11 / 11).toFixed(2)}`,
  //     value: x11 / 11,
  //     parcel: 11
  //   },
  //   {
  //     desc: `12x de R$${(x12 / 12).toFixed(2)}`,
  //     value: x12 / 12,
  //     parcel: 12
  //   }
  // ];
  return prices;
}

export { useInstallmentNew };
